module.exports = new __parcel__URL__("WrappedBitcoin.a9abc558.svg").toString();